import React from 'react';
import { Button, Chip } from '@mui/material';
import { formatDateForExport, formatVolumeCell } from 'utils/helpers/format';
import * as R from 'ramda';
import palette from 'library/theme/palette';

const confirmationColumns = handleEditClick => {
  return [
    {
      field: 'reconsignmentId',
      headerName: 'Recon. Id',
      sortable: true,
      width: 200,
    },
    {
      field: 'fromLocation',
      headerName: 'From Location',
      sortable: true,
      width: 200,
    },
    {
      field: 'toLocation',
      headerName: 'To Location',
      sortable: true,
      width: 200,
    },
    {
      field: 'status',
      headerName: 'Status',
      renderCell: ({ row }) => [
        R.equals('BOOKED', R.prop('status', row)) && (
          <Chip
            color="success"
            label="Booked"
            sx={{
              '& > .MuiChip-label': { px: 0 },
              borderRadius: 0.5,
              fontSize: 12,
              height: 20,
              px: 1,
              py: 0.5,
              width: 65,
            }}
          />
        ),
        R.equals('CANNOT BOOK', R.prop('status', row)) && (
          <Chip
            color="error"
            label="Cannot Book"
            sx={{
              '& > .MuiChip-label': { px: 0 },
              borderRadius: 0.5,
              fontSize: 12,
              height: 20,
              px: 1,
              py: 0.5,
              width: 92,
            }}
          />
        ),
        R.equals('SCHEDULED', R.prop('status', row)) && (
          <Chip
            label="Scheduled"
            sx={{
              '& > .MuiChip-label': { px: 0 },
              backgroundColor: palette.success.light,
              borderRadius: 0.5,
              fontSize: 12,
              height: 20,
              minWidth: 'none',
              px: 1,
              py: 0.5,
              width: 'min-content',
            }}
          />
        ),
        R.equals('EXPIRED', R.prop('status', row)) && (
          <Chip
            color="info"
            label="Expired"
            sx={{
              '& > .MuiChip-label': { px: 0 },
              borderRadius: 0.5,
              fontSize: 12,
              height: 20,
              px: 1,
              py: 0.5,
              width: 65,
            }}
          />
        ),
        R.equals('CANCELED', R.prop('status', row)) && (
          <Chip
            color="info"
            label="Canceled"
            sx={{
              '& > .MuiChip-label': { px: 0 },
              borderRadius: 0.5,
              fontSize: 12,
              height: 20,
              px: 1,
              py: 0.5,
              width: 75,
            }}
          />
        ),
      ],
      sortable: true,
      width: 150,
    },
    {
      field: 'transferVolume',
      headerName: 'Transfer Volume (bbls)',
      sortable: true,
      type: 'number',
      valueFormatter: formatVolumeCell,
      width: 200,
    },
    {
      field: 'transferDate',
      headerName: 'Transfer Date',
      sortable: true,
      type: 'dateTime',
      valueFormatter: formatDateForExport('MM/dd/yyyy'),
      width: 200,
    },
    {
      field: 'bookedDate',
      flex: 1,
      headerName: 'Booked Date',
      minwidth: 360,
      sortable: true,
      type: 'dateTime',
      valueFormatter: formatDateForExport('MM/dd/yyyy'),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      renderCell: ({ row }) => {
        return (
          (R.propEq('status', 'CANNOT BOOK', row) || R.propEq('status', 'SCHEDULED', row)) && (
            <Button onClick={() => handleEditClick(row.reconsignmentId)} variant="outlined">
              Edit
            </Button>
          )
        );
      },
      sortable: true,
      width: 200,
    },
  ];
};

export default confirmationColumns;
